// src/types/schedule.ts
// 統一的排程項目型別定義

import { TimeBox } from './timeBox';
import { Event } from './calendar-event';

// 統一的排程項目聯合型別
export type ScheduleItem = TimeBox | Event;

// 排程項目型別檢查輔助函數
export const isTimeBox = (item: ScheduleItem): item is TimeBox => {
  return item.itemType === 'timebox'; // 注意：TimeBox 使用 'timebox'
};

export const isEvent = (item: ScheduleItem): item is Event => {
  return item.itemType === 'event';
};

// 獲取排程項目的開始時間（統一接口）
export const getScheduleItemStartTime = (item: ScheduleItem): Date => {
  if (isTimeBox(item)) {
    return item.startTime;
  } else {
    return item.startTime;
  }
};

// 獲取排程項目的結束時間（統一接口）
export const getScheduleItemEndTime = (item: ScheduleItem): Date => {
  if (isTimeBox(item)) {
    return item.endTime;
  } else {
    return item.endTime || item.startTime;
  }
};

// 獲取排程項目的標題（統一接口）
export const getScheduleItemTitle = (item: ScheduleItem): string => {
  return item.title;
};

// 獲取排程項目的ID（統一接口）
export const getScheduleItemId = (item: ScheduleItem): string => {
  return item.id;
};

// 排程項目排序函數
export const sortScheduleItems = (items: ScheduleItem[]): ScheduleItem[] => {
  return [...items].sort((a, b) => {
    const aTime = getScheduleItemStartTime(a);
    const bTime = getScheduleItemStartTime(b);
    return aTime.getTime() - bTime.getTime();
  });
};